<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<el-col :span="5">
						<div class="sf-input-group-wrapper">
							<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001707') }}</span>
							<el-date-picker
								v-model="searchDateRange"
								type="daterange"
								align="right"
								:start-placeholder="getMessage_('QWCC000920')"
								:end-placeholder="getMessage_('QWCC000954')"
								range-separator="~"
							/>
						</div>
					</el-col>
					<el-col :span="4">
						<search-input
							:label="getMessage_('QWCC001452')"
							paramKey="custCd"
							@commInput="setSearchParam"
							:clearable="false"
							:propData="searchParams.custNm"
						>
							<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPqyCpnyPopup"></i></template>
						</search-input>
					</el-col>
					<el-col :span="4">
						<search-input
							:label="getMessage_('QWCC001936')"
							paramKey="pmcNo"
							@commInput="setSearchParam"
							:clearable="false"
							:propData="searchParams.pmcNo"
						>
							<template v-slot:icon> <i class="icon-sf-search search-icon" @click="pmcPopupOpen"></i></template>
						</search-input>
					</el-col>
					<el-col :span="3">
						<div class="sf-input-group-wrapper">
							<span class="sf-input-group-wrapper__label">&nbsp;</span>
							<div>
								<el-checkbox @input="value => onCheck('lastYn', value)">{{ getMessage_('QWCC001886') }}</el-checkbox>
							</div>
						</div>
					</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
			<!-- 팝업추가 영역 -->
			<comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId"></comp-popup>
			<pmc-popup ref="pmcPopup" @Refresh="refresh" :scrId="scrId" @sendPmc="getPmc"></pmc-popup>
		</div>
	</div>
</template>

<script>
import SearchInput from '@qms/Components/SearchInput';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';
import PmcPopup from './Popup/PmcPopup.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	components: { SearchInput, CompPopup,PmcPopup },
	data() {
		return {
			searchDateRange: []
		};
	},
	async created() {
		try {
			this.searchDateRange = [...this.getSearchDates_];
			await this.getCommCodes_({ key: 'oputStCdList', codeType: 'OPUT_ST' });
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message || error
			});
		}
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.setSearchParam_({ key: 'strDt', value: '' });
				this.setSearchParam_({ key: 'endDt', value: '' });
			}
			if (newValue?.length == 2) {
				const strDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				this.setSearchParam_({ key: 'strDt', value: strDt });
				this.setSearchParam_({ key: 'endDt', value: endDt });
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		pmcPopupOpen() {
			this.$refs.pmcPopup.open();
		},
		async getPmc({ pmcNo, ipnNos, custCd, custNm }) {
			// this.$sf_toggleLoading(true);
			this.setSearchParam_({ key: 'pmcNo', value: pmcNo });
			this.setSearchParam_({ key: 'ipnNos', value: ipnNos });
			this.setSearchParam_({ key: 'custCd', value: custCd });
			// this.setSelectedRow_({ key: 'pmcNo', value: pmcNo });
			// this.setSelectedRow_({ key: 'ipnNos', value: ipnNos });
			// this.setSelectedRow_({ key: 'custCd', value: custCd });
			// this.setSelectedRow_({ key: 'custNm', value: custNm });
			// await this.getList_();
			// this.$sf_toggleLoading(false);
		},
		onCheck(key, value) {
			// console.log(value);
			if (value) {
				this.setSearchParam_({ key, value: 'Y' });
			} else {
				this.setSearchParam_({ key, value: 'N' });
			}
		},
		//협력사조회 팝업
		onPqyCpnyPopup() {
			let params = {
				cpnyScn: '20',
				cpnyCd: this.searchParams.custCd
			};
			this.$refs.compPopup.open(params);
		},
		qpyCpnyData({ cpnyCd, cpnyNm }) {
			this.setSearchParam_({ key: 'custCd', value: cpnyCd });
			this.setSearchParam_({ key: 'custNm', value: cpnyNm });
		},
		setSearchParam(param) {
			if (param.key === 'pmcNo') {
				this.setSearchParam_({ key: 'ipnNos', value: '' });
			}
			this.setSearchParam_(param);
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				if (!this.isPqyUser) throw new Error(this.getMessage_('QWCC001923')); //해당메뉴에 접근 권한이 없습니다. 관리자에게 권한을 요청하세요.
				await this.getList_();
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error?.message
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
